import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "row crm:items-center crm:mb-6" }
const _hoisted_3 = { class: "control-label col-sm-6" }
const _hoisted_4 = { class: "col-sm" }
const _hoisted_5 = { class: "row crm:items-center crm:mb-6" }
const _hoisted_6 = { class: "control-label col-sm-6" }
const _hoisted_7 = { class: "col-sm" }
const _hoisted_8 = { class: "row crm:items-center crm:mb-6" }
const _hoisted_9 = { class: "control-label col-sm-6" }
const _hoisted_10 = { class: "col-sm" }
const _hoisted_11 = { class: "row crm:items-center crm:mb-6" }
const _hoisted_12 = { class: "control-label col-sm-6" }
const _hoisted_13 = { class: "col-sm" }
const _hoisted_14 = { class: "row crm:items-center crm:mb-6" }
const _hoisted_15 = { class: "control-label col-sm-6" }
const _hoisted_16 = { class: "col-sm" }
const _hoisted_17 = { class: "row crm:items-center crm:mb-6" }
const _hoisted_18 = { class: "control-label col-sm-6" }
const _hoisted_19 = { class: "col-sm" }
const _hoisted_20 = { class: "row crm:items-center crm:mb-6" }
const _hoisted_21 = { class: "control-label col-sm-6" }
const _hoisted_22 = { class: "col-sm" }
const _hoisted_23 = { class: "row crm:items-center crm:mb-6" }
const _hoisted_24 = { class: "control-label col-sm-6" }
const _hoisted_25 = { class: "col-sm" }
const _hoisted_26 = { class: "row crm:items-center crm:mb-6" }
const _hoisted_27 = { class: "control-label col-sm-6" }
const _hoisted_28 = { class: "col-sm" }
const _hoisted_29 = { class: "row crm:items-center crm:mb-6" }
const _hoisted_30 = { class: "control-label col-sm-6" }
const _hoisted_31 = { class: "col-sm" }
const _hoisted_32 = { class: "row crm:items-center crm:mb-6" }
const _hoisted_33 = { class: "control-label col-sm-6" }
const _hoisted_34 = { class: "col-sm" }
const _hoisted_35 = {
  key: 0,
  class: "row crm:items-center crm:mb-6"
}
const _hoisted_36 = { class: "control-label col-sm-6" }
const _hoisted_37 = { class: "col-sm" }
const _hoisted_38 = { key: 1 }
const _hoisted_39 = { class: "row crm:items-center crm:mb-6" }
const _hoisted_40 = { class: "control-label col-sm-6" }
const _hoisted_41 = { class: "col-sm" }
const _hoisted_42 = { class: "row crm:items-center crm:mb-6" }
const _hoisted_43 = { class: "control-label col-sm-6" }
const _hoisted_44 = { class: "col-sm" }
const _hoisted_45 = {
  key: 0,
  class: "row crm:items-center crm:mb-6"
}
const _hoisted_46 = { class: "control-label col-sm-6" }
const _hoisted_47 = { class: "col-sm" }
const _hoisted_48 = { class: "row crm:items-center crm:mb-6" }
const _hoisted_49 = { class: "control-label col-sm-6" }
const _hoisted_50 = { class: "col-sm" }
const _hoisted_51 = { class: "row crm:items-center crm:mb-6" }
const _hoisted_52 = { class: "control-label col-sm-6" }
const _hoisted_53 = { class: "col-sm" }
const _hoisted_54 = { class: "row crm:items-center crm:mb-6" }
const _hoisted_55 = { class: "control-label col-sm-6" }
const _hoisted_56 = { class: "col-sm" }
const _hoisted_57 = { class: "row crm:items-center crm:mb-6" }
const _hoisted_58 = { class: "control-label col-sm-6" }
const _hoisted_59 = { class: "col-sm" }
const _hoisted_60 = { class: "row crm:items-center crm:mb-6" }
const _hoisted_61 = { class: "control-label col-sm-6" }
const _hoisted_62 = { class: "col-sm" }
const _hoisted_63 = {
  key: 1,
  class: "row crm:items-center crm:mb-6"
}
const _hoisted_64 = { class: "control-label col-sm-6" }
const _hoisted_65 = { class: "col-sm" }

import { ref, watch , inject} from 'vue';
import { usePreventivo } from '../../composable/usePreventivo'
import FormImmobiliareHelper from "./../../pages/preventivi/json/immobiliare/helper.json";
import DettaglioPreventivoHelper from "../../pages/preventivi/json/dettagliopreventivo/helper.json";
import CalcoloEquoCompenso from "./CalcoloEquoCompenso.vue";
import RegimeFiscale from "./RegimeFiscale.vue";
import AliquoteContributiRepertoriali from "./AliquoteContributiRepertoriali.vue";

export default {
  __name: 'FormImmobiliareCasaTerreno',
  props: {
  formName: String,
  tipoPreventivo: Object,
  disabilita: Boolean,
  readonly: Boolean
},
  emits: ['changeDatiPreventivo','infoCompilazione'],
  setup(__props, { emit: __emit }) {

const {
  categoriaImmobiliare
} = usePreventivo();
const props = __props;
let validazione;
const validazioneEquoCompenso = ref();
let valoreSecondoGarageModificato = ref(false);
let valoreRenditaCatastaleTerrenoModificato = ref(false);
const testoInfoCompilazione = ref([]);
const { regimeFiscale } = inject('regimeFiscale')
const emits = __emit;
function secondaCasaSelezionato (event) {
  // Alla selezione di seconda casa, DL 73 non è più obbligatorio e ritenuta è ancora abilitato
  if (event.target.checked) {
    validazione.detrazione_credito_imposta.value = '';
    validazione.detrazione_credito_preliminare.value = '';
  }
}

function dl25Selezionato (event) {
  // Alla selezione Sì, D.L. 73 è applicabile - i checkbox seconda casa e ritenuta acconto vengolo disabilitati
  if (event.target.checked) {
    if(validazione.non_agevolato) {
      validazione.non_agevolato.value = 0
      validazione.non_agevolato.disabled = true
    }
    validazione.ritenuta_acconto.value = 0
    validazione.ritenuta_acconto.disabled = true
  } else {
    if(validazione.non_agevolato) {
      validazione.non_agevolato.disabled = false
    }
    validazione.ritenuta_acconto.disabled = false
  }
}

switch (props.formName) {
  case 'primaSecondaCasaTerrenoTraPrivati':
    validazione = categoriaImmobiliare['sottocategoriaCasaTerreno']['primaSecondaCasaTerrenoTraPrivati'];
    validazioneEquoCompenso.value = categoriaImmobiliare['sottocategoriaCasaTerreno']['primaSecondaCasaTerrenoTraPrivati'];
    break
  case 'primaSecondaCasaTerrenoTraPrivatiImmobileNonAccatastato':
    validazione = categoriaImmobiliare['sottocategoriaCasaTerreno']['primaSecondaCasaTerrenoTraPrivatiImmobileNonAccatastato'];
    validazioneEquoCompenso.value = categoriaImmobiliare['sottocategoriaCasaTerreno']['primaSecondaCasaTerrenoTraPrivatiImmobileNonAccatastato'];
    break
}
// Aggiungiamo il valore a tipo_parametro che sarà un path alla pagina (mantenendo il nome)
if(validazione){
  validazione.tipo_preventivo.value = 'immobiliare/casa_terreno/' + props.tipoPreventivo.data.url
}

watch(valoreRenditaCatastaleTerrenoModificato,(newValue,oldValue)=>{
  validazione.terreno_agricolo.value = valoreRenditaCatastaleTerrenoModificato.value;
  validazione.terreno_agricolo.disabled = valoreRenditaCatastaleTerrenoModificato.value;
  validazione.terreno_di_pertinenza.value = valoreRenditaCatastaleTerrenoModificato.value;
  validazione.terreno_di_pertinenza.disabled = valoreRenditaCatastaleTerrenoModificato.value;
})

watch(validazione, (newValue, oldValue) => {

  if(newValue.rendite_e_pertinenze_non_agevolabili && newValue.rendite_e_pertinenze_non_agevolabili.value != '' &&  newValue.rendite_e_pertinenze_non_agevolabili.value != '0'){
    valoreSecondoGarageModificato.value = true;
  } else {
    valoreSecondoGarageModificato.value = false;
  };

  if(newValue.rendita_catastale_secondo_garage && newValue.rendita_catastale_terreno.value != '' &&  newValue.rendita_catastale_terreno.value != '0'){
    valoreRenditaCatastaleTerrenoModificato.value = 1;
  } else {
    valoreRenditaCatastaleTerrenoModificato.value = 0;
  };
  emits('changeDatiPreventivo');
}, { deep: true })

testoInfoCompilazione.value =  FormImmobiliareHelper.sottocategoriaCasaTerreno[props.formName];
let indexHelperClosing= {
  calcolo: FormImmobiliareHelper.sottocategoriaCasaTerreno[props.formName],
  dettaglio: DettaglioPreventivoHelper.dettaglioPreventivo.descrizioni
}
emits('infoCompilazione',  testoInfoCompilazione);

return (_ctx, _cache) => {
  const _component_the_helper = _resolveComponent("the-helper")
  const _component_base_input_text = _resolveComponent("base-input-text")
  const _component_base_select = _resolveComponent("base-select")
  const _component_base_input_checkbox = _resolveComponent("base-input-checkbox")
  const _directive_fallcohelper = _resolveDirective("fallcohelper")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_the_helper, {
      list: _unref(indexHelperClosing),
      "is-closing": true
    }, null, 8 /* PROPS */, ["list"]),
    (__props.formName === 'primaSecondaCasaTerrenoTraPrivati')
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_3, [
              _createTextVNode(_toDisplayString(_unref(validazione).prezzo.label), 1 /* TEXT */)
            ])), [
              [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.prezzo.ref]
            ]),
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_base_input_text, {
                id: "prezzo",
                name: "prezzo",
                class: "placeholder-right",
                placeholder: "0,00",
                disabled: __props.readonly,
                "validate-to": _unref(validazione).prezzo,
                "onUpdate:validateTo": _cache[0] || (_cache[0] = $event => ((_unref(validazione).prezzo) = $event))
              }, null, 8 /* PROPS */, ["disabled", "validate-to"])
            ])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_6, [
              _createTextVNode(_toDisplayString(_unref(validazione).rendite_prima_casa_e_pertinenze_agevolabili.label), 1 /* TEXT */)
            ])), [
              [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.rendite_prima_casa_e_pertinenze_agevolabili.ref]
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_base_input_text, {
                id: "rendite_prima_casa_e_pertinenze_agevolabili",
                name: "rendite_prima_casa_e_pertinenze_agevolabili",
                class: "placeholder-right",
                placeholder: "0,00",
                disabled: __props.readonly,
                "validate-to": _unref(validazione).rendite_prima_casa_e_pertinenze_agevolabili,
                "onUpdate:validateTo": _cache[1] || (_cache[1] = $event => ((_unref(validazione).rendite_prima_casa_e_pertinenze_agevolabili) = $event))
              }, null, 8 /* PROPS */, ["disabled", "validate-to"])
            ])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_9, [
              _createTextVNode(_toDisplayString(_unref(validazione).rendite_e_pertinenze_non_agevolabili.label), 1 /* TEXT */)
            ])), [
              [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.rendite_e_pertinenze_non_agevolabili.ref]
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createVNode(_component_base_input_text, {
                id: "rendite_e_pertinenze_non_agevolabili",
                name: "rendite_e_pertinenze_non_agevolabili",
                class: "placeholder-right",
                placeholder: "0,00",
                disabled: __props.readonly,
                "validate-to": _unref(validazione).rendite_e_pertinenze_non_agevolabili,
                "onUpdate:validateTo": _cache[2] || (_cache[2] = $event => ((_unref(validazione).rendite_e_pertinenze_non_agevolabili) = $event))
              }, null, 8 /* PROPS */, ["disabled", "validate-to"])
            ])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_12, [
              _createTextVNode(_toDisplayString(_unref(validazione).forma_del_titolo.label), 1 /* TEXT */)
            ])), [
              [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.forma_del_titolo.ref]
            ]),
            _createElementVNode("div", _hoisted_13, [
              _createVNode(_component_base_select, {
                name: "forma_del_titolo",
                options: [{name: 'Pubblico', value: 'pubblico'},{name: 'Privato', value: 'privato'}],
                isSelected: _unref(validazione).forma_del_titolo.value != '',
                state: __props.readonly == true ?'disable':'',
                validateTo: _unref(validazione).forma_del_titolo,
                "onUpdate:validateTo": _cache[3] || (_cache[3] = $event => ((_unref(validazione).forma_del_titolo) = $event))
              }, null, 8 /* PROPS */, ["isSelected", "state", "validateTo"])
            ])
          ]),
          _createElementVNode("div", _hoisted_14, [
            _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_15, [
              _createTextVNode(_toDisplayString(_unref(validazione).detrazione_credito_imposta.label), 1 /* TEXT */)
            ])), [
              [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.detrazione_credito_imposta.ref]
            ]),
            _createElementVNode("div", _hoisted_16, [
              _createVNode(_component_base_input_text, {
                id: "detrazione_credito_imposta",
                name: "detrazione_credito_imposta",
                class: "placeholder-right",
                placeholder: "0,00",
                disabled: __props.readonly,
                "validate-to": _unref(validazione).detrazione_credito_imposta,
                "onUpdate:validateTo": _cache[4] || (_cache[4] = $event => ((_unref(validazione).detrazione_credito_imposta) = $event))
              }, null, 8 /* PROPS */, ["disabled", "validate-to"])
            ])
          ]),
          _createElementVNode("div", _hoisted_17, [
            _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_18, [
              _createTextVNode(_toDisplayString(_unref(validazione).detrazione_credito_preliminare.label), 1 /* TEXT */)
            ])), [
              [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.detrazione_credito_preliminare.ref]
            ]),
            _createElementVNode("div", _hoisted_19, [
              _createVNode(_component_base_input_text, {
                id: "detrazione_credito_preliminare",
                name: "detrazione_credito_preliminare",
                class: "placeholder-right",
                placeholder: "0,00",
                disabled: __props.readonly,
                "validate-to": _unref(validazione).detrazione_credito_preliminare,
                "onUpdate:validateTo": _cache[5] || (_cache[5] = $event => ((_unref(validazione).detrazione_credito_preliminare) = $event))
              }, null, 8 /* PROPS */, ["disabled", "validate-to"])
            ])
          ]),
          _cache[22] || (_cache[22] = _createElementVNode("hr", { class: "mb-3" }, null, -1 /* CACHED */)),
          _createElementVNode("div", _hoisted_20, [
            _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_21, [
              _createTextVNode(_toDisplayString(_unref(validazione).valore_terreno.label), 1 /* TEXT */)
            ])), [
              [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.valore_terreno.ref]
            ]),
            _createElementVNode("div", _hoisted_22, [
              _createVNode(_component_base_input_text, {
                id: "valore_terreno",
                name: "valore_terreno",
                class: "placeholder-right",
                placeholder: "0,00",
                disabled: __props.readonly,
                "validate-to": _unref(validazione).valore_terreno,
                "onUpdate:validateTo": _cache[6] || (_cache[6] = $event => ((_unref(validazione).valore_terreno) = $event))
              }, null, 8 /* PROPS */, ["disabled", "validate-to"])
            ])
          ]),
          _createElementVNode("div", _hoisted_23, [
            _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_24, [
              _createTextVNode(_toDisplayString(_unref(validazione).rendita_catastale_terreno.label), 1 /* TEXT */)
            ])), [
              [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.rendita_catastale_terreno.ref]
            ]),
            _createElementVNode("div", _hoisted_25, [
              _createVNode(_component_base_input_text, {
                id: "rendita_catastale_terreno",
                name: "rendita_catastale_terreno",
                class: "placeholder-right",
                placeholder: "0,00",
                disabled: __props.readonly,
                "validate-to": _unref(validazione).rendita_catastale_terreno,
                "onUpdate:validateTo": _cache[7] || (_cache[7] = $event => ((_unref(validazione).rendita_catastale_terreno) = $event))
              }, null, 8 /* PROPS */, ["disabled", "validate-to"])
            ])
          ]),
          _createElementVNode("div", _hoisted_26, [
            _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_27, [
              _createTextVNode(_toDisplayString(_unref(validazione).terreno_agricolo.label), 1 /* TEXT */)
            ])), [
              [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.terreno_agricolo.ref]
            ]),
            _createElementVNode("div", _hoisted_28, [
              _createVNode(_component_base_input_checkbox, {
                class: _normalizeClass(props.disabilita ? 'crm:opacity-20  crm:pointer-events-none':''),
                name: "terreno_agricolo",
                label: "Si, è agricolo",
                "validate-to": _unref(validazione).terreno_agricolo,
                "onUpdate:validateTo": _cache[8] || (_cache[8] = $event => ((_unref(validazione).terreno_agricolo) = $event))
              }, null, 8 /* PROPS */, ["class", "validate-to"])
            ])
          ]),
          _createElementVNode("div", _hoisted_29, [
            _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_30, [
              _createTextVNode(_toDisplayString(_unref(validazione).terreno_di_pertinenza.label), 1 /* TEXT */)
            ])), [
              [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.terreno_di_pertinenza.ref]
            ]),
            _createElementVNode("div", _hoisted_31, [
              _createVNode(_component_base_input_checkbox, {
                class: _normalizeClass(props.disabilita ? 'crm:opacity-20  crm:pointer-events-none':''),
                name: "terreno_di_pertinenza",
                label: "Si, è di pertinenza",
                "validate-to": _unref(validazione).terreno_di_pertinenza,
                "onUpdate:validateTo": _cache[9] || (_cache[9] = $event => ((_unref(validazione).terreno_di_pertinenza) = $event))
              }, null, 8 /* PROPS */, ["class", "validate-to"])
            ])
          ]),
          _cache[23] || (_cache[23] = _createElementVNode("hr", { class: "mb-3" }, null, -1 /* CACHED */)),
          _createElementVNode("div", _hoisted_32, [
            _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_33, [
              _createTextVNode(_toDisplayString(_unref(validazione).repertorio_proporzionato.label), 1 /* TEXT */)
            ])), [
              [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.repertorio_proporzionato.ref]
            ]),
            _createElementVNode("div", _hoisted_34, [
              _createVNode(_component_base_input_checkbox, {
                class: _normalizeClass(props.disabilita ? 'crm:opacity-20  crm:pointer-events-none':''),
                name: "repertorio_proporzionato",
                label: "Si, è repertorio proporzionato",
                "validate-to": _unref(validazione).repertorio_proporzionato,
                "onUpdate:validateTo": _cache[10] || (_cache[10] = $event => ((_unref(validazione).repertorio_proporzionato) = $event))
              }, null, 8 /* PROPS */, ["class", "validate-to"])
            ])
          ]),
          (_unref(regimeFiscale) == 'ordinario')
            ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_36, [
                  _createTextVNode(_toDisplayString(_unref(validazione).ritenuta_acconto.label), 1 /* TEXT */)
                ])), [
                  [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.ritenuta_acconto.ref]
                ]),
                _createElementVNode("div", _hoisted_37, [
                  _createVNode(_component_base_input_checkbox, {
                    class: _normalizeClass(props.disabilita ? 'crm:opacity-20  crm:pointer-events-none':''),
                    name: "ritenuta_acconto",
                    label: "Si, applicabile",
                    "validate-to": _unref(validazione).ritenuta_acconto,
                    "onUpdate:validateTo": _cache[11] || (_cache[11] = $event => ((_unref(validazione).ritenuta_acconto) = $event))
                  }, null, 8 /* PROPS */, ["class", "validate-to"])
                ])
              ]))
            : _createCommentVNode("v-if", true),
          _createVNode(RegimeFiscale, {
            validazione: _unref(validazione),
            helper: _unref(indexHelperClosing),
            readonly: __props.readonly
          }, null, 8 /* PROPS */, ["validazione", "helper", "readonly"]),
          _createVNode(AliquoteContributiRepertoriali, {
            validazione: _unref(validazione),
            helper: _unref(indexHelperClosing),
            readonly: __props.readonly
          }, null, 8 /* PROPS */, ["validazione", "helper", "readonly"]),
          _createVNode(CalcoloEquoCompenso, {
            "input-riferimento-calcolo": ['prezzo','valore_terreno'],
            validazione: validazioneEquoCompenso.value,
            helper: _unref(indexHelperClosing),
            readonly: __props.readonly
          }, null, 8 /* PROPS */, ["validazione", "helper", "readonly"])
        ]))
      : (__props.formName === 'primaSecondaCasaTerrenoTraPrivatiImmobileNonAccatastato')
        ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
            _createElementVNode("div", _hoisted_39, [
              _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_40, [
                _createTextVNode(_toDisplayString(_unref(validazione).prezzo.label), 1 /* TEXT */)
              ])), [
                [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.prezzo.ref]
              ]),
              _createElementVNode("div", _hoisted_41, [
                _createVNode(_component_base_input_text, {
                  id: "prezzo",
                  name: "prezzo",
                  class: "placeholder-right",
                  placeholder: "0,00",
                  disabled: __props.readonly,
                  "validate-to": _unref(validazione).prezzo,
                  "onUpdate:validateTo": _cache[12] || (_cache[12] = $event => ((_unref(validazione).prezzo) = $event))
                }, null, 8 /* PROPS */, ["disabled", "validate-to"])
              ])
            ]),
            _createElementVNode("div", _hoisted_42, [
              _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_43, [
                _createTextVNode(_toDisplayString(_unref(validazione).forma_del_titolo.label), 1 /* TEXT */)
              ])), [
                [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.forma_del_titolo.ref]
              ]),
              _createElementVNode("div", _hoisted_44, [
                _createVNode(_component_base_select, {
                  name: "forma_del_titolo",
                  options: [{name: 'Pubblico', value: 'pubblico'},{name: 'Privato', value: 'privato'}],
                  isSelected: _unref(validazione).forma_del_titolo.value != '',
                  state: __props.readonly == true ?'disable':'',
                  validateTo: _unref(validazione).forma_del_titolo,
                  "onUpdate:validateTo": _cache[13] || (_cache[13] = $event => ((_unref(validazione).forma_del_titolo) = $event))
                }, null, 8 /* PROPS */, ["isSelected", "state", "validateTo"])
              ])
            ]),
            (_unref(validazione).non_agevolato.value == false)
              ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
                  _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_46, [
                    _createTextVNode(_toDisplayString(_unref(validazione).detrazione_credito_imposta.label), 1 /* TEXT */)
                  ])), [
                    [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.detrazione_credito_imposta.ref]
                  ]),
                  _createElementVNode("div", _hoisted_47, [
                    _createVNode(_component_base_input_text, {
                      id: "detrazione_credito_imposta",
                      name: "detrazione_credito_imposta",
                      class: "placeholder-right",
                      placeholder: "0,00",
                      disabled: __props.readonly,
                      "validate-to": _unref(validazione).detrazione_credito_imposta,
                      "onUpdate:validateTo": _cache[14] || (_cache[14] = $event => ((_unref(validazione).detrazione_credito_imposta) = $event))
                    }, null, 8 /* PROPS */, ["disabled", "validate-to"])
                  ])
                ]))
              : _createCommentVNode("v-if", true),
            _createElementVNode("div", _hoisted_48, [
              _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_49, [
                _createTextVNode(_toDisplayString(_unref(validazione).detrazione_credito_preliminare.label), 1 /* TEXT */)
              ])), [
                [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.detrazione_credito_preliminare.ref]
              ]),
              _createElementVNode("div", _hoisted_50, [
                _createVNode(_component_base_input_text, {
                  id: "detrazione_credito_preliminare",
                  name: "detrazione_credito_preliminare",
                  class: "placeholder-right",
                  placeholder: "0,00",
                  disabled: __props.readonly,
                  "validate-to": _unref(validazione).detrazione_credito_preliminare,
                  "onUpdate:validateTo": _cache[15] || (_cache[15] = $event => ((_unref(validazione).detrazione_credito_preliminare) = $event))
                }, null, 8 /* PROPS */, ["disabled", "validate-to"])
              ])
            ]),
            _createElementVNode("div", _hoisted_51, [
              _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_52, [
                _createTextVNode(_toDisplayString(_unref(validazione).non_agevolato.label), 1 /* TEXT */)
              ])), [
                [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.non_agevolato.ref]
              ]),
              _createElementVNode("div", _hoisted_53, [
                _createVNode(_component_base_input_checkbox, {
                  class: _normalizeClass(props.disabilita ? 'crm:opacity-20  crm:pointer-events-none':''),
                  name: "non_agevolato",
                  label: "Si, tassazione non agevolata",
                  onChange: _cache[16] || (_cache[16] = $event => (!props.disabilita ? secondaCasaSelezionato($event) : '')),
                  "validate-to": _unref(validazione).non_agevolato,
                  "onUpdate:validateTo": _cache[17] || (_cache[17] = $event => ((_unref(validazione).non_agevolato) = $event))
                }, null, 8 /* PROPS */, ["class", "validate-to"])
              ])
            ]),
            _cache[24] || (_cache[24] = _createElementVNode("hr", { class: "mb-3" }, null, -1 /* CACHED */)),
            _createElementVNode("div", _hoisted_54, [
              _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_55, [
                _createTextVNode(_toDisplayString(_unref(validazione).valore_terreno.label), 1 /* TEXT */)
              ])), [
                [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.valore_terreno.ref]
              ]),
              _createElementVNode("div", _hoisted_56, [
                _createVNode(_component_base_input_text, {
                  id: "valore_terreno",
                  name: "valore_terreno",
                  class: "placeholder-right",
                  placeholder: "0,00",
                  disabled: __props.readonly,
                  "validate-to": _unref(validazione).valore_terreno,
                  "onUpdate:validateTo": _cache[18] || (_cache[18] = $event => ((_unref(validazione).valore_terreno) = $event))
                }, null, 8 /* PROPS */, ["disabled", "validate-to"])
              ])
            ]),
            _createElementVNode("div", _hoisted_57, [
              _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_58, [
                _createTextVNode(_toDisplayString(_unref(validazione).terreno_agricolo.label), 1 /* TEXT */)
              ])), [
                [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.terreno_agricolo.ref]
              ]),
              _createElementVNode("div", _hoisted_59, [
                _createVNode(_component_base_input_checkbox, {
                  class: _normalizeClass(props.disabilita ? 'crm:opacity-20  crm:pointer-events-none':''),
                  name: "terreno_agricolo",
                  label: "Si, è agricolo",
                  "validate-to": _unref(validazione).terreno_agricolo,
                  "onUpdate:validateTo": _cache[19] || (_cache[19] = $event => ((_unref(validazione).terreno_agricolo) = $event))
                }, null, 8 /* PROPS */, ["class", "validate-to"])
              ])
            ]),
            _createElementVNode("div", _hoisted_60, [
              _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_61, [
                _createTextVNode(_toDisplayString(_unref(validazione).terreno_di_pertinenza.label), 1 /* TEXT */)
              ])), [
                [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.terreno_di_pertinenza.ref]
              ]),
              _createElementVNode("div", _hoisted_62, [
                _createVNode(_component_base_input_checkbox, {
                  class: _normalizeClass(props.disabilita ? 'crm:opacity-20  crm:pointer-events-none':''),
                  name: "terreno_di_pertinenza",
                  label: "Si, è di pertinenza",
                  "validate-to": _unref(validazione).terreno_di_pertinenza,
                  "onUpdate:validateTo": _cache[20] || (_cache[20] = $event => ((_unref(validazione).terreno_di_pertinenza) = $event))
                }, null, 8 /* PROPS */, ["class", "validate-to"])
              ])
            ]),
            _cache[25] || (_cache[25] = _createElementVNode("hr", { class: "mb-3" }, null, -1 /* CACHED */)),
            (_unref(regimeFiscale) == 'ordinario')
              ? (_openBlock(), _createElementBlock("div", _hoisted_63, [
                  _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_64, [
                    _createTextVNode(_toDisplayString(_unref(validazione).ritenuta_acconto.label), 1 /* TEXT */)
                  ])), [
                    [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.ritenuta_acconto.ref]
                  ]),
                  _createElementVNode("div", _hoisted_65, [
                    _createVNode(_component_base_input_checkbox, {
                      class: _normalizeClass(props.disabilita ? 'crm:opacity-20  crm:pointer-events-none':''),
                      name: "ritenuta_acconto",
                      label: "Si, applicabile",
                      "validate-to": _unref(validazione).ritenuta_acconto,
                      "onUpdate:validateTo": _cache[21] || (_cache[21] = $event => ((_unref(validazione).ritenuta_acconto) = $event))
                    }, null, 8 /* PROPS */, ["class", "validate-to"])
                  ])
                ]))
              : _createCommentVNode("v-if", true),
            _createVNode(RegimeFiscale, {
              validazione: _unref(validazione),
              helper: _unref(indexHelperClosing),
              readonly: __props.readonly
            }, null, 8 /* PROPS */, ["validazione", "helper", "readonly"]),
            _createVNode(AliquoteContributiRepertoriali, {
              validazione: _unref(validazione),
              helper: _unref(indexHelperClosing),
              readonly: __props.readonly
            }, null, 8 /* PROPS */, ["validazione", "helper", "readonly"]),
            _createVNode(CalcoloEquoCompenso, {
              "input-riferimento-calcolo": ['prezzo','valore_terreno'],
              validazione: validazioneEquoCompenso.value,
              helper: _unref(indexHelperClosing),
              readonly: __props.readonly
            }, null, 8 /* PROPS */, ["validazione", "helper", "readonly"])
          ]))
        : _createCommentVNode("v-if", true)
  ], 64 /* STABLE_FRAGMENT */))
}
}

}